import { createContext, useContext } from "react";
import type { FarmView, FarmEvent } from "./transitions";

type FarmViewContextType = {
  view: FarmView;
  dispatchEvent: (event: FarmEvent) => void;
};

export const FarmViewContext3 = createContext<FarmViewContextType | null>(null);

export const useFarmView3 = (): FarmViewContextType => { 
  const context: FarmViewContextType | null = useContext(FarmViewContext3);

  if (context === null) {
    throw new Error("You must add a <FarmViewProvider> into the React tree");
  }

  return context;
};